import { render, staticRenderFns } from "./FormSeat.vue?vue&type=template&id=16179476&"
import script from "./FormSeat.vue?vue&type=script&lang=js&"
export * from "./FormSeat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports